import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import VPNServices from './components/VPNServices';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Features />
      <VPNServices />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}
